import clsx from "clsx";
import Link from "next/link";

import { formatDate, getNextCutoffs } from "@chef/helpers";
import { BRAND_PATHS } from "@chef/constants";
import { intl } from "./SimpleWeekSwitcherBar.Intl";
interface SimpleWeekSwitcherBarProps {
  week: number;
  year: number;
}

export const SimpleWeekSwitcherBar = ({
  week,
  year,
}: SimpleWeekSwitcherBarProps) => {
  const nextFourWeeks = getNextCutoffs();

  return (
    <header className="sticky top-0 z-40 flex items-center justify-center gap-2 py-2 bg-white border-t-1.5 border-grey-2 shadow-inner-sm">
      {nextFourWeeks.map(({ week: w, year: y, date: d }) => {
        const isActive = w === week && y === year;

        return (
          <Link
            href={`${BRAND_PATHS.MY_MENU_LOGOUT_PAGE}/${w}/${y}`}
            key={`${w}-${y}`}
            passHref
            className={clsx(
              isActive ? "text-white bg-primary" : "hover:bg-grey-2",
              "relative flex flex-col items-center justify-center w-22 p-2 text-sm rounded",
            )}
          >
            <div className="z-5">
              {intl.WEEK} {w}
            </div>
            <div className="z-5">
              <strong>{formatDate(d, "d. MMM")}</strong>
            </div>
          </Link>
        );
      })}
    </header>
  );
};
